export default "__VITE_ASSET__a389cab2__"